{
    "monster": {
        "key": "monster",

        "jobKey": "book/ooze",
        "position": {
            "x": 9,
            "y": 5,
            "z": 1
        }
    },
    "54Ft8": {
        "position": {
            "x": 6,
            "y": 5,
            "z": 1
        },
        "templateKey": "jobs/ember/torch",
        "jobKey": "book/terrain",
        "key": "54Ft8"
    },
    "ashe": {
        "position": {
            "x": 2,
            "y": 5,
            "z": 1
        },
        "templateKey": "player/book/ashe",
        "key": "ashe"
    },
    "xtgor": {
        "position": {
            "x": 4,
            "y": 5,
            "z": 1
        },
        "stack": -1,
        "templateKey": "tree",
        "type": "zone",
        "role": "tree",
        "properties": [
            "no healthbar"
        ],
        "imageKey": "book/mess",
        "spriteSize": "contained",
        "key": "xtgor",
        "previousMultiselect": [
            "xtgor",
            "xtgor",
            "3RCv_",
            "3RCv_",
            "RU5ez",
            "RU5ez"
        ]
    },
    "3RCv_": {
        "position": {
            "x": 6,
            "y": 6,
            "z": 1
        },
        "stack": -1,
        "templateKey": "tree",
        "type": "zone",
        "role": "tree",
        "properties": [
            "no healthbar"
        ],
        "imageKey": "book/mess",
        "spriteSize": "contained",
        "key": "3RCv_",
        "previousMultiselect": [
            "xtgor",
            "xtgor",
            "3RCv_",
            "3RCv_",
            "RU5ez",
            "RU5ez"
        ]
    },
    "RU5ez": {
        "position": {
            "x": 6,
            "y": 7,
            "z": 1
        },
        "stack": -1,
        "templateKey": "tree",
        "type": "zone",
        "role": "tree",
        "properties": [
            "no healthbar"
        ],
        "imageKey": "book/mess",
        "spriteSize": "contained",
        "key": "RU5ez",
        "previousMultiselect": [
            "xtgor",
            "xtgor",
            "3RCv_",
            "3RCv_",
            "RU5ez",
            "RU5ez"
        ]
    },
    "TdaTp": {
        "position": {
            "x": 8,
            "y": 5,
            "z": 1
        },
        "stack": -1,
        "templateKey": "tree",
        "type": "zone",
        "role": "tree",
        "properties": [
            "no healthbar"
        ],
        "imageKey": "book/mess",
        "spriteSize": "contained",
        "key": "TdaTp",
        "previousMultiselect": [
            "xtgor",
            "xtgor",
            "3RCv_",
            "3RCv_",
            "RU5ez",
            "RU5ez"
        ]
    },
    "page": {
        "key": "page",
        "role": "page",
        "type": "zone",
        "spriteSize": "contained", "imageKey": "book/page1",
        "properties": [
            "no healthbar"
        ],

        "position": {
            "x": 3,
            "y": 5,
            "z": 1
        },
        "pageKeys": [
            "werewolf", "manmoth", "unicorn"
        ]
    }
}
